import { render } from "./NoticePage.vue?vue&type=template&id=0e5fc309&scoped=true"
import script from "./NoticePage.vue?vue&type=script&lang=js"
export * from "./NoticePage.vue?vue&type=script&lang=js"

import "./NoticePage.vue?vue&type=style&index=0&id=0e5fc309&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0e5fc309"

export default script